import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

interface TermsWebLinkProps {
  linkName: string;
  selectedTerms: string;
  link?: string;
  onClick?: () => void;
}

export const TermsWebLink: React.FC<TermsWebLinkProps> = ({
  linkName,
  link,
  onClick,
}) => (
  <LinkButton
    type="button"
    onClick={() => {
      if (onClick) {
        onClick();
        return;
      }

      if (link) {
        window.open(link);
      }
    }}
  >
    {linkName}
  </LinkButton>
);

const LinkButton = styled.button`
  ${TypographyV2.s1}
  align-self: flex-start;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${ColorV2.Blue1};
  cursor: pointer;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`;
